import { Color3, Scene, StandardMaterial, Texture, Vector3 } from '@babylonjs/core';
import { TColor, TMaterial, TMeshInstanceData } from './type';

export const removeClone = (meshName, scene) => {
	const mesh = scene.getMeshByName(meshName);
	if (!mesh) return;
	const instancesLength = mesh.instances.length;
	if (instancesLength > 0) {
		for (let index = 0; index <= instancesLength; index++) {
			let oldBalusterClone = scene.getMeshByName(`${meshName}_${index}`);
			if (oldBalusterClone) oldBalusterClone.dispose();
		}
	}
};

export const createInstanceMesh = (data: TMeshInstanceData) => {
	let {
		meshName,
		meshClone,
		space,
		startPoint,
		endPoint,
		divisions,
		parentName,
		cloneFull,
		scene,
		meshInstanceName,
	} = data;
	const nameInstancePrefix = meshInstanceName ? meshInstanceName : meshName;
	if (!meshClone) {
		meshClone = scene.getMeshByName(meshName);
	}

	if (space <= 0 || !meshClone) return;

	const distance = Vector3.Distance(startPoint, endPoint);

	if (!divisions) {
		divisions = Math.ceil(distance / (space / 12));
	}
	let start = 0;
	let end = divisions;
	let results = [];

	const parentMesh = '' !== parentName ? scene.getMeshByName(parentName) : false;
	if (divisions == 1) {
		const instance = meshClone.createInstance(`${nameInstancePrefix}_0`);
		const position = Vector3.Center(startPoint, endPoint);
		instance.position = position;
		results.push(instance);
		instance.isPickable = false;
		instance.alwaysSelectAsActiveMesh = true;
		instance.setEnabled(true);
		if (parentMesh) instance.setParent(parentMesh);
	} else {
		for (start; start < end; start++) {
			if (!cloneFull && (start === 0 || start === end - 1)) {
				continue;
			}
			const instance = meshClone.createInstance(`${nameInstancePrefix}_${start}`);
			const position = Vector3.Lerp(startPoint, endPoint, (1 / (divisions - 1)) * start);
			instance.position = position;
			results.push(instance);
			instance.isPickable = false;
			instance.alwaysSelectAsActiveMesh = true;
			instance.setEnabled(true);
			if (parentMesh) instance.setParent(parentMesh);
		}
	}

	return results;
};

/**
 * Create or reuse a StandardMaterial by name
 * - Reuse existing material if already created
 * - Create new material from provided material data
 * - Apply color and specular settings
 */
export const createMaterial = (
	materialName: string,
	color: TColor,
	materialData: TMaterial,
	scene: Scene,
) => {
	let material = new StandardMaterial(materialName, scene);
	material.diffuseTexture = new Texture(materialData.diffuse, scene);
	material.bumpTexture = new Texture(materialData.bump, scene);
	if (materialData.opa) {
		material.opacityTexture = new Texture(materialData.opa, scene);
		material.opacityTexture.hasAlpha = true;
		material.opacityTexture.getAlphaFromRGB = true;
	} else {
		material.opacityTexture = null;
	}
	material.specularTexture = new Texture(materialData.specular, scene);

	if (color && 'color' === color.type && '' !== color.code) {
		material.diffuseColor = Color3.FromHexString(color.code);
	}

	if (color && 'image' === color.type && '' !== color.image) {
		material.diffuseTexture = new Texture(color.image, scene);
	}

	return material;
};
